<template>
  <div id="div1" @onmousemove="moveMouse" @mouseover="overMouse" @mouseout="outMouse">
    <a v-for="hot in hot_words"
       v-bind:key="hot">{{ hot }}</a>
  </div>
</template>

<script>

export default {
  name: "TagBall",
  data: () => ({
    radius: 78,
    dtr: Math.PI / 180,
    d: 150,

    mcList: [],
    active: false,
    lasta: 1,
    lastb: 1,
    distr: true,
    tspeed: 2,
    size: 250,

    mouseX: 0,
    mouseY: 0,

    howElliptical: 1,

    aA: null,
    oDiv: null,
    sa: null,
    ca: null,
    sb: null,
    cb: null,
    sc: null,
    cc: null,
  }),
  props: ['hot_words'],
  mounted() {
    this.init();
  },
  methods: {
    moveMouse: function (ev) {
      const appDiv = this.oDiv;
      const oEvent = window.event || ev;

      this.mouseX = oEvent.clientX - (appDiv.offsetLeft + appDiv.offsetWidth / 2);
      this.mouseY = oEvent.clientY - (appDiv.offsetTop + appDiv.offsetHeight / 2);

      this.mouseX /= 5;
      this.mouseY /= 5;
    },
    overMouse: function () {
      this.active = true;
    },
    outMouse: function () {
      this.active = false;
    },
    init: function () {
      let i;
      let oTag = null;

      this.oDiv = document.getElementById('div1');

      this.aA = this.oDiv.getElementsByTagName('a');

      for (i = 0; i < this.aA.length; i++) {
        oTag = {};

        oTag.offsetWidth = this.aA[i].offsetWidth;
        oTag.offsetHeight = this.aA[i].offsetHeight;

        this.mcList.push(oTag);
      }

      this.sineCosine(0, 0, 0);

      this.positionAll();

      setInterval(this.update, 30);
    },
    update: function () {
      let a;
      let b;

      if (this.active) {
        a = (-Math.min(Math.max(-this.mouseY, -this.size), this.size) / this.radius) * this.tspeed;
        b = (Math.min(Math.max(-this.mouseX, -this.size), this.size) / this.radius) * this.tspeed;
      } else {
        a = this.lasta * 0.98;
        b = this.lastb * 0.98;
      }

      this.lasta = 0.3;
      this.lastb = 0.3;

      if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
        return
      }

      const c = 0;
      this.sineCosine(a, b, c);
      for (let j = 0; j < this.mcList.length; j++) {
        const rx1 = this.mcList[j].cx;
        const ry1 = this.mcList[j].cy * this.ca + this.mcList[j].cz * (-this.sa);
        const rz1 = this.mcList[j].cy * this.sa + this.mcList[j].cz * this.ca;

        const rx2 = rx1 * this.cb + rz1 * this.sb;
        const ry2 = ry1;
        const rz2 = rx1 * (-this.sb) + rz1 * this.cb;

        const rx3 = rx2 * this.cc + ry2 * (-this.sc);
        const ry3 = rx2 * this.sc + ry2 * this.cc;
        const rz3 = rz2;

        this.mcList[j].cx = rx3;
        this.mcList[j].cy = ry3;
        this.mcList[j].cz = rz3;

        this.per = this.d / (this.d + rz3);

        this.mcList[j].x = (this.howElliptical * rx3 * this.per) - (this.howElliptical * 2);
        this.mcList[j].y = ry3 * this.per;
        this.mcList[j].scale = this.per;
        this.mcList[j].alpha = this.per;

        this.mcList[j].alpha = (this.mcList[j].alpha - 0.6) * (10 / 6);
      }

      this.doPosition();
      this.depthSort();

    },
    depthSort: function () {
      let i;
      const aTmp = [];

      for (i = 0; i < this.aA.length; i++) {
        aTmp.push(this.aA[i]);
      }

      aTmp.sort((vItem1, vItem2) => {
            if (vItem1.cz > vItem2.cz) {
              return -1;
            } else if (vItem1.cz < vItem2.cz) {
              return 1;
            } else {
              return 0;
            }
          }
      );

      for (i = 0; i < aTmp.length; i++) {
        aTmp[i].style.zIndex = i;
      }
    },
    positionAll: function () {
      let phi = 0;
      let theta = 0;
      const max = this.mcList.length;
      let i;

      const aTmp = [];
      const oFragment = document.createDocumentFragment();

      //随机排序
      for (i = 0; i < this.aA.length; i++) {
        aTmp.push(this.aA[i]);
      }

      aTmp.sort(() => {
        return Math.random() < 0.5 ? 1 : -1;
      });

      for (i = 0; i < aTmp.length; i++) {
        oFragment.appendChild(aTmp[i]);
      }

      this.oDiv.appendChild(oFragment);

      for (i = 1; i < max + 1; i++) {
        if (this.distr) {
          phi = Math.acos(-1 + (2 * i - 1) / max);
          theta = Math.sqrt(max * Math.PI) * phi;
        } else {
          phi = Math.random() * (Math.PI);
          theta = Math.random() * (2 * Math.PI);
        }
        //坐标变换
        this.mcList[i - 1].cx = this.radius * Math.cos(theta) * Math.sin(phi);
        this.mcList[i - 1].cy = this.radius * Math.sin(theta) * Math.sin(phi);
        this.mcList[i - 1].cz = this.radius * Math.cos(phi);

        this.aA[i - 1].style.left = this.mcList[i - 1].cx + this.oDiv.offsetWidth / 2 - this.mcList[i - 1].offsetWidth / 2 + 'px';
        this.aA[i - 1].style.top = this.mcList[i - 1].cy + this.oDiv.offsetHeight / 2 - this.mcList[i - 1].offsetHeight / 2 + 'px';
      }
    },
    doPosition: function () {
      const l = this.oDiv.offsetWidth / 2;
      const t = this.oDiv.offsetHeight / 2;
      for (let i = 0; i < this.mcList.length; i++) {
        this.aA[i].style.left = this.mcList[i].cx + l - this.mcList[i].offsetWidth / 2 + 'px';
        this.aA[i].style.top = this.mcList[i].cy + t - this.mcList[i].offsetHeight / 2 + 'px';

        this.aA[i].style.fontSize = Math.ceil(12 * this.mcList[i].scale / 2) + 8 + 'px';

        this.aA[i].style.filter = "alpha(opacity=" + 100 * this.mcList[i].alpha + ")";
        this.aA[i].style.opacity = this.mcList[i].alpha;
      }
    },
    sineCosine: function (a, b, c) {
      this.sa = Math.sin(a * this.dtr);
      this.ca = Math.cos(a * this.dtr);
      this.sb = Math.sin(b * this.dtr);
      this.cb = Math.cos(b * this.dtr);
      this.sc = Math.sin(c * this.dtr);
      this.cc = Math.cos(c * this.dtr);
    }
  }
}
</script>

<style scoped>
#div1 {
  height: 180px;
  width: 450px;
  position: relative;
  margin: 10px auto;
}

#div1 a {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  font-weight: bold;
  padding: 3px 6px;
}

#div1 a:hover {
  border: 1px solid #eee;
  background: #000;
  border-radius: 5px;
}
</style>